import { TextField, TextFieldProps } from '@mui/material';

export interface SimpleTextInputProps extends Omit<TextFieldProps, 'name' | 'value' | 'onChange'> {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  disabled?: boolean;
  required?: boolean;
  helperText?: string;
  placeholder?: string;
  type?: 'text' | 'email' | 'password' | 'number' | 'tel' | 'url';
  inputProps?: TextFieldProps['inputProps'];
  error?: boolean;
}

export function SimpleTextInput({
  value,
  onChange,
  label,
  disabled,
  required,
  helperText,
  placeholder,
  type = 'text',
  inputProps,
  error,
  ...textFieldProps
}: SimpleTextInputProps) {
  return (
    <TextField
      {...textFieldProps}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      fullWidth
      label={label}
      type={type}
      placeholder={placeholder}
      disabled={disabled}
      required={required}
      error={error}
      helperText={helperText}
      inputProps={inputProps}
    />
  );
}